<div class="container">
  <div class="row">
    <div class="card" style="width: 100%">
      <div class="card-body">
        <p>{{ "APPEALS_DASHBOARD_STATIC_TEXT" | globalTranslate }}</p>
        @if (appealDetailsRows?.length && appealStatusTrackerSwitch) {
        <nh-alert type="info" [isOpen]="true">
          <div class="mb-3 row align-items-center">
            <div class="col-auto icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="23.5" viewBox="0 0 26 23.5">
                <path id="checkbox"
                  d="M70,48H52a3.827,3.827,0,0,0-4,3.615V67.885A3.827,3.827,0,0,0,52,71.5H70a3.827,3.827,0,0,0,4-3.615V51.615A3.827,3.827,0,0,0,70,48m-2.234,7.812-8.4,9.038a1.045,1.045,0,0,1-.75.323H58.6a1.05,1.05,0,0,1-.743-.3l-3.6-3.615a.842.842,0,0,1-.226-.893.971.971,0,0,1,.753-.613,1.063,1.063,0,0,1,.959.3l2.831,2.843,7.662-8.243a1.075,1.075,0,0,1,1.409-.111.845.845,0,0,1,.123,1.273"
                  transform="translate(-48 -48)" fill="#174a7c" />
              </svg>
            </div>
            <div class="col message">
              <span class="visually-hidden">{{"Alert" | globalTranslate}}</span>
              <span class="text_color">{{ "APPEAL_TRACKER_BANNER" | globalTranslate }}</span>
              <span><a tabindex="0" (click)="goToAppealTracker()" (keydown.enter)="goToAppealTracker()" class="add-primary-color pointer"><b>{{'APPEAL_TRACKER_BANNER_01' | globalTranslate
                    }}</b></a></span>
            </div>
          </div>
        </nh-alert>
        }
        @if (appealDetailsRows?.length) {
        <div>
          <h1 class="section-header">
            {{
              (medicalAppealsSwitch
                ? "ELIGIBILIY_APPEALS_HEADER"
                : "APPEAL_DETAILS"
              ) | globalTranslate
            }}
          </h1>
          <hr />
          <nh-alert type="warning" [isOpen]="uploadProofTrue">
            <div class="row">
              <div class="col-auto icon">
                <img
                  src="../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                  alt=""
                />
              </div>
              <div class="col message">
                <span class="visually-hidden">{{
                  "Alert" | globalTranslate
                }}</span>
                <span
                  [innerHtml]="'UPLOAD_APPEAL_PROOF' | globalTranslate"
                ></span>
                <span
                  ><b
                    [innerHtml]="'UPLOAD_APPEAL_PROOF_01' | globalTranslate"
                  ></b
                ></span>
                <span
                  [innerHtml]="'UPLOAD_APPEAL_PROOF_02' | globalTranslate"
                ></span>
              </div>
            </div>
          </nh-alert>
          <div class="d-none d-lg-block">
            <ngx-datatable
              class="bootstrap striped"
              #table
              [rows]="appealDetailsRows"
              [limit]="5"
              columnMode="force"
              [headerHeight]="'auto'"
              [footerHeight]="50"
              [rowHeight]="'auto'"
            >
              <ngx-datatable-column
                [cellClass]="'my-auto'"
                [name]="appealDetailsColumns[0].name | globalTranslate"
                [prop]="appealDetailsColumns[0].prop"
              >
              </ngx-datatable-column>
              <ngx-datatable-column
                [cellClass]="'my-auto'"
                [name]="appealDetailsColumns[1].name | globalTranslate"
                [prop]="appealDetailsColumns[1].prop"
              >
              </ngx-datatable-column>
              <ngx-datatable-column
                [cellClass]="'my-auto'"
                [name]="appealDetailsColumns[2].name | globalTranslate"
                [prop]="appealDetailsColumns[2].prop"
              >
              </ngx-datatable-column>
              <ngx-datatable-column
                [cellClass]="'my-auto'"
                [name]="appealDetailsColumns[3].name | globalTranslate"
              >
                <ng-template ngx-datatable-cell-template let-row="row">
                  {{ row.appealReasonValue | globalTranslate }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column
                [cellClass]="'my-auto'"
                [name]="appealDetailsColumns[4].name | globalTranslate"
              >
                <ng-template ngx-datatable-cell-template let-row="row">
                  {{ row.appealStatusValue | globalTranslate }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column
                [cellClass]="'my-auto'"
                [name]="appealDetailsColumns[5].name | globalTranslate"
              >
                <ng-template ngx-datatable-cell-template let-row="row">
                  {{ row.coverageType | globalTranslate }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column [cellClass]="'my-auto'" [width]="180">
                <ng-template let-column="column" ngx-datatable-header-template
                  >{{ AppealsAction | globalTranslate }}
                  <nh-popover
                    [iconMode]="'transparent'"
                    [content]="'Appeal_Action_Info' | globalTranslate"
                  ></nh-popover>
                </ng-template>
                <ng-template
                  ngx-datatable-cell-template
                  let-row="row"
                  let-rowIndex="rowIndex"
                >
                  @if (row && ((row.uploadAppealAiProof !== null &&
                  row.uploadAppealAiProof === true) || (row.uploadAppealProofVfd
                  !== null && row.uploadAppealProofVfd === false))) {
                  <div>
                    <button
                      class="btn btn-block btn-outline-secondary-proof"
                      (click)="uploadProof(row)"
                    >
                      <span>{{ "UPLOAD_APL_DOC" | globalTranslate }}</span>
                    </button>
                  </div>
                  } @if (row && (row.uploadAppealProofVfd !== null &&
                  row.uploadAppealProofVfd === true)) {
                  <div>
                    <button
                      class="btn btn-block btn-outline-secondary-proof"
                      (click)="openAppealFactRequestPop(row)"
                    >
                      <span>{{ "UPLOAD_APL_INFO" | globalTranslate }}</span>
                    </button>
                  </div>
                  } @if (row && row.fileContinuance !== null &&
                  row.fileContinuance === true) {
                  <div class="p-0 hover-red">
                    <a
                      class="p-0 hover-red btn btn-link text-center"
                      style="overflow-wrap: anywhere"
                      (click)="fileContinuance(row)"
                      tabindex="0"
                    >
                      <span style="font-size: 14px">{{
                        "FILE_A_CONTINUANCE" | globalTranslate
                      }}</span></a
                    >
                  </div>
                  } @if (row && row.fileWithrawal !== null && row.fileWithrawal
                  === true) {
                  <div class="p-0 hover-red">
                    <a
                      class="p-0 hover-red btn btn-link text-center"
                      style="overflow-wrap: anywhere"
                      (click)="fileWithdrawal(row)"
                      tabindex="0"
                    >
                      <span style="font-size: 14px">{{
                        "FILE_A_WITHDRAWAL" | globalTranslate
                      }}</span></a
                    >
                  </div>
                  }<br />
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
          <div class="nh-table-mobile d-lg-none">
            @for (row of appealDetailsRows; track row) {
            <div class="table-row mb-3 pb-3">
              <div class="mobile-table-header">
                {{ appealDetailsColumns[0].name | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">{{ row.memberName }}</div>
              <br />
              <div class="mobile-table-header">
                {{ appealDetailsColumns[1].name | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">{{ row.appealNumber }}</div>
              <br />
              <!-- <div class="mobile-table-header">{{appealDetailsColumns[2].name | globalTranslate}}</div>
                                    <hr>
                                      <div class="mobile-table-data">{{row.caseNumber}}</div>
                                      <br> -->
              <div class="mobile-table-header">
                {{ appealDetailsColumns[2].name | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">{{ row.appealFilingDate }}</div>
              <br />
              <div class="mobile-table-header">
                {{ appealDetailsColumns[3].name | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">
                {{ row.appealReasonValue | globalTranslate }}
              </div>
              <br />
              <div class="mobile-table-header">
                {{ appealDetailsColumns[4].name | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">
                {{ row.appealStatusValue | globalTranslate }}
              </div>
              <br />
              <!-- <div class="mobile-table-header">{{appealDetailsColumns[5].name | globalTranslate}}</div>
                                                  <hr>
                                                    <div class="mobile-table-data">{{row.hearingDate}}</div>
                                                    <br> -->
              <div class="mobile-table-header">
                {{ appealDetailsColumns[5].name | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">
                {{ row.coverageType | globalTranslate }}
              </div>
              <br />
              <div class="mobile-table-header d-inline">
                {{ "AppealsAction" | globalTranslate }}
              </div>
              <nh-popover
                [content]="'Appeal_Action_Info' | globalTranslate"
              ></nh-popover>
              <hr />
              @if (row && ((row.uploadAppealAiProof !== null &&
              row.uploadAppealAiProof === true) || (row.uploadAppealProofVfd !==
              null && row.uploadAppealProofVfd === false))) {
              <div>
                <button
                  class="btn btn-block btn-outline-secondary-proof"
                  (click)="uploadProof(row)"
                >
                  <span>{{ "UPLOAD_APL_DOC" | globalTranslate }}</span>
                </button>
              </div>
              } @if (row && (row.uploadAppealProofVfd !== null &&
              row.uploadAppealProofVfd === true)) {
              <div>
                <button
                  class="btn btn-block btn-outline-secondary-proof"
                  (click)="openAppealFactRequestPop(row)"
                >
                  <span>{{ "UPLOAD_APL_INFO" | globalTranslate }}</span>
                </button>
              </div>
              }
              <br />
              @if (row && row.fileContinuance !== null && row.fileContinuance
              === true) {
              <div class="p-0 hover-red" style="overflow: auto">
                <a
                  class="p-0 hover-red btn btn-link text-center"
                  (click)="fileContinuance(row)"
                  tabindex="0"
                >
                  <span>{{ "FILE_A_CONTINUANCE" | globalTranslate }}</span></a
                >
              </div>
              }<br />
              @if (row && row.fileWithrawal !== null && row.fileWithrawal ===
              true) {
              <div class="p-0 hover-red" style="overflow: auto">
                <a
                  class="p-0 hover-red btn btn-link text-center"
                  (click)="fileWithdrawal(row)"
                  tabindex="0"
                >
                  <span>{{ "FILE_A_WITHDRAWAL" | globalTranslate }}</span></a
                >
              </div>
              }<br />
            </div>
            }
          </div>
        </div>
        } @if (appealPetitionDetailsRows?.length) {
        <div>
          <h2 class="section-header">
            {{ "APPEAL_PETITION" | globalTranslate }}
          </h2>
          <hr />
          <div class="row">
            <div class="col message">
              <span
                [innerHtml]="'APPEAL_PETITION_STATIC_TXT' | globalTranslate"
              ></span>
            </div>
          </div>
          <hr />
          <div class="d-none d-lg-block">
            <ngx-datatable
              class="bootstrap striped"
              #table
              [rows]="appealPetitionDetailsRows"
              [limit]="5"
              columnMode="force"
              [headerHeight]="'auto'"
              [footerHeight]="50"
              [rowHeight]="'auto'"
            >
              @for (col of appealPetitionColumns; track col) {
              <ngx-datatable-column
                [cellClass]="'my-auto'"
                [name]="col.name | globalTranslate"
                [prop]="col.prop"
              >
              </ngx-datatable-column>
              }
              <ngx-datatable-column [cellClass]="'my-auto'" [width]="180">
                <ng-template let-column="column" ngx-datatable-header-template
                  >{{ AppealsAction | globalTranslate }}
                  <!-- <nh-popover [iconMode]="'transparent'" [content]="'Appeal_Action_Info' | translate"></nh-popover> -->
                </ng-template>
                <ng-template
                  ngx-datatable-cell-template
                  let-row="row"
                  let-rowIndex="rowIndex"
                >
                  @if (row) {
                  <div>
                    <button
                      class="btn btn-block btn-outline-secondary-proof"
                      (click)="openAppealPetitionRequestPop(row)"
                    >
                      <span>{{ "UPLOAD_APL_PET_BTN" | globalTranslate }}</span>
                    </button>
                  </div>
                  }
                  <br />
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
          <div class="nh-table-mobile d-lg-none">
            @for (row of appealPetitionDetailsRows; track row) {
            <div class="table-row mb-3 pb-3">
              <div class="mobile-table-header">
                {{ appealPetitionColumns[0].name | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">{{ row.memberName }}</div>
              <br />
              <div class="mobile-table-header">
                {{ appealPetitionColumns[1].name | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">{{ row.appealNumber }}</div>
              <br />
              <div class="mobile-table-header">
                {{ appealPetitionColumns[2].name | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">{{ row.appealFilingDate }}</div>
              <br />
              <div class="mobile-table-header">
                {{ appealPetitionColumns[3].name | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">
                {{ row.appealReasonValue | globalTranslate }}
              </div>
              <br />
              <div class="mobile-table-header">
                {{ appealPetitionColumns[4].name | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">
                {{ row.appealStatusValue | globalTranslate }}
              </div>
              <br />
              <!-- <div class="mobile-table-header">{{appealPetitionColumns[5].name | translate}}</div> -->
              <hr />
              <div class="mobile-table-data">
                {{ row.coverageType | globalTranslate }}
              </div>
              <br />
              <div class="mobile-table-header d-inline">
                {{ "AppealsAction" | globalTranslate }}
              </div>
              <nh-popover
                [content]="'Appeal_Action_Info' | globalTranslate"
              ></nh-popover>
              <hr />
              @if (row) {
              <div>
                <button
                  class="btn btn-block btn-outline-secondary-proof"
                  (click)="openAppealPetitionRequestPop(row)"
                >
                  <span>{{ "UPLOAD_APL_PET_BTN" | globalTranslate }}</span>
                </button>
              </div>
              }
              <br />
            </div>
            }
          </div>
        </div>
        }
        <div class="d-none d-lg-block">
          <div class="row" style="padding-left: 15px">
            <div class="p-1 file_appeal">
              <button
                (click)="startApp('APL')"
                class="btn btn-secondary btn-search"
                [disabled]="!enableFileAppealButton"
              >
                {{ "FILE_A_NEW_APPEAL" | globalTranslate }}
              </button>
            </div>
            @if (showViewMyLetters) {
            <div class="p-1">
              <button
                (click)="appealLetters()"
                class="btn btn-secondary btn-search"
                [disabled]="false"
              >
                {{ "VIEW_MY_APPEAL_LETTERS" | globalTranslate }}
              </button>
            </div>
            } @if (!showViewMyLetters) {
            <div class="p-5 d-none d-lg-block col"></div>
            } @if (!showViewMyLetters) {
            <div class="p-5 d-none d-lg-block col"></div>
            } @if (!showViewMyLetters && translatedLang !== 'en') {
            <div class="p-4 d-none d-lg-block col"></div>
            } @if (translatedLang === 'en') {
            <div class="p-5 d-none d-lg-block col"></div>
            } @if (translatedLang === 'en') {
            <div class="p-5 d-none d-lg-block col"></div>
            } @if (clickViewAppeals && pastAppealDetailsRows?.length) {
            <div class="p-1">
              <button
                (click)="clickedViewAppeals()"
                class="btn btn-block btn-outline-secondary"
                [disabled]="!clickViewAppeals"
              >
                {{ "VIEW_PAST_APPEALS" | globalTranslate }}
              </button>
            </div>
            } @if (clickViewAppeals && pastAppealDetailsRows?.length) {
            <div style="margin-top: 10px">
              <nh-popover
                content="{{ 'VIEW_PAST_APPEALS_POPUP' | globalTranslate }}"
              ></nh-popover>
            </div>
            } @if (clickHideAppeals && pastAppealDetailsRows?.length) {
            <div class="p-1">
              <button
                (click)="clickedHideAppeals()"
                class="btn btn-block btn-outline-secondary"
                [disabled]="!clickHideAppeals"
              >
                {{ "HIDE_PAST_APPEALS" | globalTranslate }}
              </button>
            </div>
            } @if (clickHideAppeals && pastAppealDetailsRows?.length) {
            <div style="margin-top: 10px">
              <nh-popover
                content="{{ 'HIDE_PAST_APPEALS_POPUP' | globalTranslate }}"
              ></nh-popover>
            </div>
            }
          </div>
        </div>
        <div class="nh-table-mobile d-lg-none">
          <div class="p-1">
            <button
              (click)="startApp('APL')"
              class="btn btn-secondary btn-search"
              [disabled]="!enableFileAppealButton"
            >
              {{ "FILE_A_NEW_APPEAL" | globalTranslate }}
            </button>
          </div>
          @if (showViewMyLetters) {
          <div class="p-1">
            <button
              (click)="appealLetters()"
              class="btn btn-secondary btn-search"
              [disabled]="false"
            >
              {{ "VIEW_MY_APPEAL_LETTERS" | globalTranslate }}
            </button>
          </div>
          } @if (translatedLang === 'en') {
          <div class="p-5 d-none d-lg-block col"></div>
          } @if (translatedLang === 'en') {
          <div class="p-5 d-none d-lg-block col"></div>
          } @if (clickViewAppeals && pastAppealDetailsRows?.length) {
          <div class="row p-3 align-items-center">
            <button
              (click)="clickedViewAppeals()"
              class="col-auto btn btn-block btn-outline-secondary col"
              [disabled]="!clickViewAppeals"
            >
              {{ "VIEW_PAST_APPEALS" | globalTranslate }}
            </button>
            @if (clickViewAppeals && pastAppealDetailsRows?.length) {
            <div class="col-auto">
              <nh-popover
                content="{{ 'VIEW_PAST_APPEALS_POPUP' | globalTranslate }}"
              ></nh-popover>
            </div>
            }
          </div>
          } @if (clickHideAppeals && pastAppealDetailsRows?.length) {
          <div class="row p-3 align-items-center">
            <button
              (click)="clickedHideAppeals()"
              class="col-auto btn btn-block btn-outline-secondary col"
              [disabled]="!clickHideAppeals"
            >
              {{ "HIDE_PAST_APPEALS" | globalTranslate }}
            </button>
            @if (clickHideAppeals && pastAppealDetailsRows?.length) {
            <div class="col-auto">
              <nh-popover
                content="{{ 'HIDE_PAST_APPEALS_POPUP' | globalTranslate }}"
              ></nh-popover>
            </div>
            }
          </div>
          }
        </div>
        @if (!clickViewAppeals) {
        <div>
          <h2 class="section-header">
            {{ "PAST_APPEAL_DETAILS" | globalTranslate }}
          </h2>
          <hr />
          <div class="d-none d-lg-block">
            <ngx-datatable
              class="bootstrap striped"
              #table
              [rows]="pastAppealDetailsRows"
              [limit]="5"
              columnMode="force"
              [headerHeight]="'auto'"
              [footerHeight]="50"
              [rowHeight]="'auto'"
            >
              @for (col of pastAppealDetailsColumns; track col) {
              <ngx-datatable-column
                [cellClass]="'my-auto'"
                [name]="col.name | globalTranslate"
                [prop]="col.prop"
              >
              </ngx-datatable-column>
              }
            </ngx-datatable>
          </div>
          <div class="nh-table-mobile d-lg-none">
            @for (row of pastAppealDetailsRows; track row) {
            <div class="table-row mb-3 pb-3">
              <div class="mobile-table-header">
                {{ pastAppealDetailsColumns[0].name | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">{{ row.memberName }}</div>
              <br />
              <div class="mobile-table-header">
                {{ pastAppealDetailsColumns[1].name | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">{{ row.appealNumber }}</div>
              <br />
              <div class="mobile-table-header">
                {{ pastAppealDetailsColumns[2].name | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">{{ row.caseNumber }}</div>
              <br />
              <div class="mobile-table-header">
                {{ pastAppealDetailsColumns[3].name | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">{{ row.appealFilingDate }}</div>
              <br />
              <div class="mobile-table-header">
                {{ pastAppealDetailsColumns[4].name | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">
                {{ row.appealReasonValue | globalTranslate }}
              </div>
              <br />
              <div class="mobile-table-header">
                {{ pastAppealDetailsColumns[5].name | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">
                {{ row.pastAppealStatus | globalTranslate }}
              </div>
              <br />
              <div class="mobile-table-header">
                {{ pastAppealDetailsColumns[6].name | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">{{ row.hearingDate }}</div>
              <br />
              <div class="mobile-table-header">
                {{ pastAppealDetailsColumns[7].name | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">
                {{ row.coverageType | globalTranslate }}
              </div>
              <br />
            </div>
            } @if (!pastAppealDetailsRows?.length) {
            <p class="mb-5">{{ "NO_DATA_TO_DISPLAY" | globalTranslate }}</p>
            }
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>